export default {
  DASHBOARD: '/',
  LOGIN: '/login',
  NOT_FOUND: '/not-found',
  BROWSE: '/browse',
  PROJECTS: '/projects',
  WISHLIST: '/wishlist',
  SETTINGS: '/settings',
  HISTORY: '/history',
};
